import React from 'react';
import FinalFormInputWrapper from './FinalFormInputWrapper';
import { SelectWithTagsNew } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

const TextInputWrapper: React.FC<FieldRenderProps<any>> = (props) => (
  <FinalFormInputWrapper {...props} component={SelectWithTagsNew} />
);

export default TextInputWrapper;
